// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import question css modules
import questionStyles from '../questionModuleStyles.css';

function QuestionListItem({ question }) {
  return (
    <li>
      <Link to={`/questions/${question._id}`}> {question.name}</Link>
    </li>
  )
}

QuestionListItem.propTypes = {
  question: PropTypes.object.isRequired
}

export default QuestionListItem;



// WEBPACK FOOTER //
// modules/question/components/QuestionListItem.js.jsx